import { useClickstreamAnalytics } from 'src/analytics/hooks/useClickstreamAnalytics';
import { FunctionComponentWithChildren } from 'src/utils/types';

export const AnalyticsProvider: FunctionComponentWithChildren = ({ children }) => {
    const triggerAnalytics = useClickstreamAnalytics();
    triggerAnalytics();
    return children;
};
